const formatTimeHoursMinutes = (date: string) => {
  const dateFormat = new Date(date);
  return new Date(
    new Date().setHours(dateFormat.getHours(), dateFormat.getMinutes(), 0, 0)
  );
};
export default formatTimeHoursMinutes;
